module.exports = __webpack_public_path__ + "static/img/background.f504df02.svg";